import React from 'react';
import { Box, Typography } from '@mui/material';

interface ImportResultsStepProps {
  jobId: string;
  onFinish: () => void;
}

export const ImportResultsStep: React.FC<ImportResultsStepProps> = ({
  jobId,
  onFinish,
}) => {
  return (
    <Box>
      <Typography>Import Results Step - To be implemented</Typography>
    </Box>
  );
};